export const defaultCurrencyCode = 'USD';
export const validCurrencyCodes = ['USD', 'CAD'];

export const numberFormatOptions = { 
  style: 'currency', 
  minimumFractionDigits: 2,
  maximumFractionDigits: 2, 
};
